/**
 * Copyright © 2025-2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Navigate, RouteObject } from "react-router-dom";

import { BreakpointGate, SelectorGate } from "../../components/AppRouter/route-gates";
import { HOME_ROUTE } from "../../util/routing";
import { selectIsCEUser } from "../azure-b2c/storage";

import UserAccountScreen from "./pages/UserAccount/UserAccountScreen";
import { ACCOUNT_SETTINGS_ROUTES, AccountSettingsRouter } from "./account-settings";
import { ACCOUNT_ROUTES } from "./constants";
import { PERSONAL_DETAILS_ROUTES, PersonalDetailsRouter } from "./personal-details";
import { STATEMENTS_ROUTES, StatementsRouter } from "./statements";

export const accountRoutes: RouteObject[] = [
  {
    path: ACCOUNT_ROUTES.BASE,
    element: (
      <BreakpointGate redirectTo={HOME_ROUTE}>
        <UserAccountScreen />
      </BreakpointGate>
    ),
  },
  {
    path: PERSONAL_DETAILS_ROUTES.ROOT,
    element: (
      <SelectorGate selector={(state) => !selectIsCEUser(state)} redirectTo={HOME_ROUTE}>
        <PersonalDetailsRouter />
      </SelectorGate>
    ),
  },
  {
    path: ACCOUNT_SETTINGS_ROUTES.ROOT,
    element: <AccountSettingsRouter />,
  },
  {
    path: STATEMENTS_ROUTES.ROOT,
    element: <StatementsRouter />,
  },
  { path: ACCOUNT_ROUTES.ROOT, element: <Navigate to={ACCOUNT_ROUTES.BASE} replace /> },
];
